// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__32DUg","selects":"Documents_selects__1GVdE"};